module.exports = __webpack_public_path__ + "static/media/webpack.1501d041.svg";